import styled from "styled-components"

export const StarsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`
